import type { AttributesCount, Meta } from '../../../../generated/frontend'
import { useBackStack } from '../../../../shared/BrowserBackStackProvider'
import { getDataLayerScripts } from '../../../../shared/data-layer'
import { getDFPScripts } from '../../../../shared/dfp'
import type { PageInfo } from '../../../../shared/types/PageInfo'
import type { AppliedFilterItem } from '../../../../shared/types/ReviewsFilters'
import { getPreviousUrl } from '../../../../shared/utils/getPreviousUrl/getPreviousUrl'
import { removeFalsy } from '../../../../shared/utils/remove-falsy'
import { getDataLayerScriptContent } from '../../utils/get-data-layer-script'

export const useProductListingPageDataLayer = () => {
  const backStack = useBackStack()
  const previousUrl = getPreviousUrl({ backStack: backStack })

  return {
    getDataLayerItems({
      meta,
      attributesCount,
      appliedFilters,
      fullUrl,
      hasVariants,
    }: {
      meta: Partial<Meta>
      attributesCount: AttributesCount
      appliedFilters?: AppliedFilterItem[]
      fullUrl?: string
      hasVariants?: boolean
    }) {
      const { dataLayer = [], taxonomyHierarchy } = meta
      const dataLayerScriptContent = getDataLayerScriptContent({
        meta,
        attributesCount,
        fullUrl,
        appliedFilters,
        hasVariants,
      })

      const pageInfo: PageInfo = {
        vertical: taxonomyHierarchy?.vertical?.slug,
        sub_vertical: taxonomyHierarchy?.subVertical?.slug,
        category: taxonomyHierarchy?.category?.slug,
        content_type: 'product-listing',
        pageType: 'product-listing',
        ...(previousUrl && { previousWcdPageUrl: previousUrl }),
      }

      return [
        ...getDataLayerScripts([...dataLayer, removeFalsy(dataLayerScriptContent)]),
        ...getDFPScripts(dataLayer, pageInfo),
      ]
    },
  }
}
